import { createStore } from 'vuex';
import { getLandingPageStructure } from "../api/LandingPage";
import { addUserDetails } from "../helpers/helpers";

export default createStore({
  state() {
    return {
      submissionFields: {},
      landingPageStructure: {},
      token: null,
      appStatus: null,
      userSettings: null //object { valid: bool, status: string}
    };
  },
  mutations: {
    setSubmissionFields(state, submissionFields) {
      state.submissionFields = submissionFields
    },
    setlandingPageStructure(state, landingPage) {
      state.landingPageStructure = landingPage
    },
    setToken(state, token) {
      state.token = token
    },
    setAppStatus(state, appStatus) {
      state.appStatus = appStatus
    },
    setAppUserSettings(state, userSettings) {
      state.userSettings = userSettings
    },
  },
  actions: {
    async getlandingPageStructure(context, token) {
        try {
          const res =  await getLandingPageStructure(token)
          if(res) {
            context.commit('setlandingPageStructure',JSON.parse(JSON.stringify(res.data.landingPage)));
            context.commit('setAppUserSettings',JSON.parse(JSON.stringify(res.data.userSettings)));
            const submissionFields = {
              token: res.data.token,
              signerData: addUserDetails()
            }
            context.commit('setSubmissionFields',submissionFields);
          }
        } catch(error) {
            const appStatus = {
              valid:true,
              status: "GlobalError"
            }
            context.commit('setAppStatus',appStatus);
            throw error
        }
      }
  },
  getters: {
    submissionFields: (state) => state.submissionFields,
    landingPageStructure: (state) => state.landingPageStructure,
    token: (state) => state.token,
    appStatus: (state) => state.appStatus,
    userSettings: (state) => state.userSettings,
  }
});
